'use client';
import './style.sass';

import React from 'react';
import {
    listPath,
    listTitle,
    listStages,
    listSolutions,
    listSolutionsRoles,
    listMarker,
    listMarkerStages,
    iconsBlock,
    listCompetitions,
    listMedia,
    listResults,
} from './constans';
import TitleCase from '../../case-components/title-case';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import Target from '../reusable-components/layouts-component__aimed/target';
import LayoutPage from '../reusable-components/layouts-component__aimed/layout-page';
import Solution from '../reusable-components/layouts-component__aimed/solution';
import Marker from '../reusable-components/layouts-component__aimed/marker';
import MarkerText from '../reusable-components/layouts-component__aimed/marker-text';
import Chellenge from '../reusable-components/layouts-component__aimed/chellenge';
import Competition from '../reusable-components/layouts-component__aimed/competition';
import UniqueMarker from '../reusable-components/layouts-component__aimed/unique-marker';
import Result from '../reusable-components/layouts-component__aimed/result';
import Team from '../reusable-components/layouts-component__aimed/team';
import Review from '../reusable-components/layouts-component__aimed/review';

const nextProjectdevRec = {
    nextProjectTitle: 'Медведь. Интернет-магазин',
    nextProjectImg: '/images/png/medved.png',
    nextProjectLink: '/cases/marketing/medved',
    nextProjectLinkTitle: '',
    nextProjectText:
        'В&nbsp;этом кейсе расскажем, какие тексты нужны интернет-магазину для роста продаж без привлечение платных рекламных',
};

const Aimed = () => {
    return (
        <section>
            <TitleCase
                img="/images/pic/aimed/aimed.png"
                listPath={listPath}
                listTitle={listTitle}
                caseName="aimed"
            />
            <Target />
            <LayoutPage listStages={listStages} />
            <Solution list={listSolutions} listRoles={listSolutionsRoles} />
            <Marker />
            <MarkerText list={listMarker} listStages={listMarkerStages} />
            <Chellenge list={iconsBlock} />
            <Competition list={listCompetitions} />
            <UniqueMarker />
            <Result list={listResults} listMedia={listMedia} />
            <Team />
            <Review />
            <NextProject NextProject={nextProjectdevRec} />
        </section>
    );
};

export default Aimed;
